import { Component, OnInit, Input, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { UnitLinking, UnitArmiesDisplay } from '../models/unitLinking';
import { WriteOrdinalSuffixOfNumber } from 'starbase-launcher';
import { DataDisplayerBase } from '../data-displayer-base';
import { BreakpointService } from '../breakpoint.service';
import { currentBsVersion } from 'ngx-bootstrap/utils';


@Component({
  selector: 'app-units-display',
  templateUrl: './units-display.component.html',
  styleUrls: ['./units-display.component.css']
})


export class UnitsDisplayComponent extends DataDisplayerBase<UnitLinking> implements OnChanges {

  writeOrdinalSuffix = WriteOrdinalSuffixOfNumber;
  unitArmies = UnitArmiesDisplay;
  isHandset: boolean = false;
  private _subscription;
  oneColumnDataMobile: string = "";
  mobileData = []; 

  constructor(private breakpointService: BreakpointService){
    super();
  }

  ngOnInit() {
    this._subscription = this.breakpointService.handset$.subscribe(
      isHandset => {
        this.isHandset = isHandset;
      })
    
    if (this.isHandset) {
      this.columns = ['Units']
      console.log(this.data)

      this.data.forEach(d => {
        let currentRow =  
          (d.army ? (this.unitArmies[d.army] + ' Army, ') : '') +  
          (d.corps ? (this.writeOrdinalSuffix(d.corps) + ' Corps, ') : '') +   
          (d.regimentNo?.regimentNo ? (this.writeOrdinalSuffix(d.regimentNo.regimentNo) + ' Reg, ') : '') +  
          (d.state?.abbreviation ? (d.state.abbreviation + ', ') : '') +
          (d.branch?.branchName ? (d.branch.branchName + ', ') : '') +   
          (d.companyLetters ? (d.companyLetters + ' Company') : '');
      
        // Remove trailing comma and space, if present
        if (currentRow.endsWith(', ')) {
          currentRow = currentRow.slice(0, -2);
        }
      
        this.mobileData.push(currentRow);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    UnitLinking.setupUnitLinkCollection(this.data);
  }

}
